// 默认主题配置 默认绿色
export const defaultTheme = {
  // 主色调 - 基于UI图的蓝色渐变
  primary: '#3667E5', // 主蓝色
  primaryLight: '#6BA3F0', // 浅蓝色
  primaryHighlight: '#E8F4FD', // 高亮蓝色
  primaryNavBarBgColor: '#4A90E2', // 导航栏背景

  // 渐变色配置
  gradientStart: '#4A90E2', // 渐变起始色
  gradientEnd: '#7B68EE', // 渐变结束色
  gradientBackground: 'linear-gradient(135deg, #6BA3F0 0%, #3667E5 100%)', // 背景渐变

  // 功能色
  success: '#52C41A', // 成功色
  successLight: '#F6FFED', // 成功色浅色
  warning: '#FA8C16', // 警告色 - 橙色
  warningLight: '#FFF7E6', // 警告色浅色
  error: '#FF4D4F', // 错误色
  errorDark: '#CF1322', // 错误色深色

  // 文本色
  info: '#666666', // 信息文本
  tip: '#999999', // 提示文本
  textColorBase: '#333333', // 基础文本色
  textColorLight: '#FFFFFF', // 浅色文本（用于深色背景）
  textColorSecondary: '#8C8C8C', // 次要文本色

  // 背景色
  bgColor: '#3667E5', // 页面背景色
  cardBgColor: '#FFFFFF', // 卡片背景色
  borderColorCustom: '#E8E8E8', // 边框色

  // 阴影配置
  shadowLight: '0 0 20px rgba(74, 144, 226, 0.25)', // 浅阴影
  shadowMedium: '0 0 20px rgba(74, 144, 226, 0.45)', // 中等阴影
  shadowHeavy: '0 0 20px rgba(74, 144, 226, 0.65)', // 重阴影

  // 圆角配置
  borderRadiusSmall: '10px', // 小圆角
  borderRadiusMedium: '15px', // 中等圆角
  borderRadiusLarge: '20px', // 大圆角
  borderRadiusCard: '25px', // 卡片圆角

  // 品牌信息
  companyId: 'ocean',
  companyName: '全国中小学生海洋文化创意设计大赛',
  brandTitle: '全国中小学生海洋文化创意设计大赛',
  brandSubtitle: 'National marine culture creative design competition for primary and secondary school students',
  brandSlogan: '普及海洋知识  传播海洋文化  增强全民海洋意识',
};

export type ThemeConfig = typeof defaultTheme;
